import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {PathLocationStrategy} from "@angular/common";
import {api} from "./connect-api";
import {Utils} from "./utils";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ApplicationError} from "./application-error";
import {SESSION_STORAGE_KEYS} from "./session-storage-keys";
import {User} from "./user";
import {ErrorService} from "./error.service";
import {Router} from "@angular/router";


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private loggerUrl = (userId: string) => `${api}/users/${userId}/logClientSideError`;

    constructor(private injector: Injector , private router : Router) {
    }

    handleError(error: Error | HttpErrorResponse) {
        const errorService = this.injector.get(ErrorService);
        if (error instanceof HttpErrorResponse) {
            let stackTrace = errorService.getServerStack(error);
            let message = errorService.getServerMessage(error);
            console.log(message);
            console.log(stackTrace);
            if (error.status === 401 || error.status === 403) {
                this.router.navigate(['./login']);
            }

        } else {
            let stackTrace = errorService.getClientStack(error);
            let message = errorService.getClientMessage(error);
            console.log(stackTrace);
            console.log(message);
            this.logError(error);

        }

    }

    logError(error): void {
        let httpClient = this.injector.get(HttpClient);
        const url = location instanceof PathLocationStrategy
            ? location.pathname : '';
        let applicationError: ApplicationError = new ApplicationError();
        applicationError.message = error.message ? error.message : error.toString();
        applicationError.url = url;
        applicationError.browserInfo = Utils.getBrowserInfo();
        applicationError.status = error.status;
        applicationError.stack = error.stack;
        let user = sessionStorage.getItem(SESSION_STORAGE_KEYS.user);
        if (user) {
            let sessionUser: User = new User(JSON.parse(user));
            applicationError.userId = sessionUser.loginId;
            applicationError.accountId = sessionUser.publicAccountId;
            httpClient.put<ApplicationError>(this.loggerUrl(sessionUser.id.toString()), JSON.stringify(applicationError))
        }

    }
}
